export default "__VITE_ASSET__ot4G8pH4__"